import React from 'react';

// DigitalNext-merk: geroteerd blauw vierkant met gouden stip + woordmerk.
export const Logo: React.FC<{ size?: number; showWord?: boolean }> = ({ size = 26, showWord = true }) => (
  <span className="inline-flex items-center gap-2.5">
    <span className="relative flex-none" style={{ width: size, height: size }} aria-hidden="true">
      <span className="absolute inset-0 rounded-[7px] rotate-45" style={{ background: '#2440CF' }} />
      <span
        className="absolute rounded-full"
        style={{ left: '50%', top: '50%', width: size * 0.31, height: size * 0.31, background: '#C29A33', transform: 'translate(-50%,-50%)' }}
      />
    </span>
    {showWord && (
      <span className="font-display font-bold tracking-tight text-ink" style={{ fontSize: 20 }}>
        Digital<span className="text-royal">Next</span>
      </span>
    )}
  </span>
);
